import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { ParamDescription } from "by/gamefactory/cityversetycoon/composition/module/ParamDescription";
import { NotificationMessageType } from "./NotificationMessageType";
import { NotificationMessagesModuleExecutor } from "./NotificationMessagesModuleExecutor";
import { TournamentIntroResourcePackage } from "./resources/TournamentIntroResourcePackage";
import { UnboardingResourcePackage } from "./resources/UnboardingResourcePackage";
import { YouNoMoreOwnerResourcePackage } from "./resources/YouNoMoreOwnerResourcePackage";
import { TournamentIntroPopupScene } from "./scenes/TournamentIntroPopupScene";
import { UnboardingPopupScene, UnboardingSceneOptions } from "./scenes/UnboardingPopupScene";
import { YouNoMoreOwnerPopupScene } from "./scenes/YouNoMoreOwnerPopupScene";

export class NotificationMessagesModule extends BaseModule<void> {

    public override async build(): Promise<void> {
        await super.build();
        this.internalContainer.register(NotificationMessagesModuleExecutor, NotificationMessagesModuleExecutor);
        this.internalContainer.register("YouNoMoreOwnePopupSceneFactory", {
            useValue: async (youNoMoreOwnerResources: YouNoMoreOwnerResourcePackage) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    YouNoMoreOwnerPopupScene,
                    new ParamDescription(YouNoMoreOwnerResourcePackage, youNoMoreOwnerResources)
                );
            }
        });
        this.internalContainer.register("UnboardingPopupSceneFactory", {
            useValue: async (sceneOptions: UnboardingSceneOptions, unboardingResources: UnboardingResourcePackage) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    UnboardingPopupScene,
                    new ParamDescription("UnboardingSceneOptions", sceneOptions),
                    new ParamDescription(UnboardingResourcePackage, unboardingResources)
                );
            }
        });
        this.internalContainer.register("TournamentIntroPopupSceneFactory", {
            useValue: async (tournamentIntroResources: TournamentIntroResourcePackage) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    TournamentIntroPopupScene,
                    new ParamDescription(TournamentIntroResourcePackage, tournamentIntroResources)
                );
            }
        });
    }

    public async start(type?: NotificationMessageType): Promise<void> {
        const executor = await this.internalContainer.resolve(NotificationMessagesModuleExecutor);
        await executor.execute(this, type);
        this.dispose();
    }
}